var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGrass = function SvgGrass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 63,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71A20F",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M85.804 35.336c7.15-1.167 2.782 16.94-2.587 25.523a.97.97 0 0 1-.828.45H10.75a1.1 1.1 0 0 1-.433-.096c-4.299-1.9-8.109.899-8.478-19.664-.363-20.203 7.805-17.774 12.343-13.733.283.252.271.955.371.59.649-2.372 7.905-24.953 18.542-24.697 11.998.288 13.694 17.422 13.382 19.333-.31 1.91 10.08-26.715 23.743-20.712 13.664 6.003 6.652 31.657 1.437 43.733 1.683-3.081 6.867-9.54 14.146-10.727z"
  })));
};
export default SvgGrass;